import { render, staticRenderFns } from "./NavigationButtonMobile.vue?vue&type=template&id=85c57fc8&"
import script from "./NavigationButtonMobile.vue?vue&type=script&lang=js&"
export * from "./NavigationButtonMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports